import jwt from "jwt-decode";
import moment from "moment";
import { getCurrentUser, setCurrentUser } from "../utils/Hooks/useLocalStorage";
import fetch from "cross-fetch";

const API_URL = "/auth/";

const register = (username, email, password) => {
    return fetch(API_URL + "signup", {
        method: "POST", body: JSON.stringify({
            username,
            email,
            password,
        })
    });
}
const getLoginContext = (user) => {
    if (user && user.accessToken) {

        const userJwt = jwt(user.accessToken.token ?? user.accessToken); // decode your token here'
        const payload = {
            username: userJwt.sub,
            email: userJwt.ema,
            role: userJwt.rol,
            refresh: user.refreshToken,
            jwt: user.accessToken.token ?? user.accessToken,
            clientDepartmentId: userJwt.cdid,
            adminId: userJwt.aid,
            clientId: userJwt.clid,
            clientStaffId: userJwt.cssid,
            supplierId: userJwt.sssid,
            qGov: userJwt.qgov,
            status: userJwt.astat,
            terms: userJwt.taco !== 'True',
            serverVersion: userJwt.servver,
            managesMessages: userJwt.adme === 'true',
            managesWorkflow: userJwt.admw === 'true',
            canViewSupplierInfo: userJwt.cvsi === '1',
        };
        return payload;
    }

};
const login = async (userEmail, userPassword, dispatchSetuser, prefix) => {
    try {
        const existingCreds = getCurrentUser();
        const response = await fetch((prefix ? prefix : '') + API_URL + "login",
            {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({ userName: userEmail, password: userPassword, remoteIpAddress: '1.2.3.4', oldRefreshTokens: existingCreds?.refreshTokens ?? [] })
            });
        const data = await response.json().catch((e) => { }); // If the response isn't a JSON, return undefined
        if (data?.accessToken.token) {
            // Stop using the depracated single-refresh-token system (don't save it)
            data.refreshToken = undefined;
            setCurrentUser(data);
            const payload = getLoginContext(data);

            dispatchSetuser && dispatchSetuser({
                type: "setAuthDetails", payload
            });
            return response.data;
        }
        return { message: "Incorrect email or password." };
    } catch (value) {
        return { message: "Incorrect email or password." };
    }
}


export { register, login, getLoginContext };